
import "vue-slider-component/theme/default.css";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    vueSlider: () => import("vue-slider-component")
  }
})
export default class Location extends Vue {
  @Prop(Function) changeSelect!: any;
  @Prop(Array) filter!: any;
  data() {
    return {
      value: 0,
      msjSlot: "Escribe una ubicacion",
      optionsPlaces: [],
      checked: false,
      selectCountry: "",
      options: {
        dotSize: 14,
        width: "auto",
        height: 4,
        contained: false,
        direction: "ltr",
        data: null,
        min: 0,
        max: 50,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: "focus",
        tooltipPlacement: "top",
        tooltipFormatter: void 0,
        useKeyboard: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0
      },
      marks: {
        "0": {
          label: "0km",
          style: {
            width: "8px",
            height: "8px",
            display: "block",
            backgroundColor: "#69c0ff",
            transform: "translate(-2px, -2px)"
          },
          labelStyle: {
            color: "#7d8899"
          }
        },
        "50": {
          label: "50km",
          style: {
            width: "8px",
            height: "8px",
            display: "block",
            backgroundColor: "#69c0ff",
            transform: "translate(-2px, -2px)"
          },
          labelStyle: {
            color: "#7d8899"
          }
        }
      }
    };
  }

  async fetchOptions(search: any, loading: any) {
    if (search.length > 2) {
      loading(true);
      const response = await (this as any).$root._get(
        `misc/locations?q=${search}&addp=1`,
        {}
      );
      (this as any).optionsPlaces = response;
      loading(false);
      if (response.length === 0) {
        (this as any).msjSlot = "Lo sentimos, no hay resultados.";
      }
    } else {
      (this as any).msjSlot = "Escribe una ubicacion";
    }
  }
}
